import React, { useContext, useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import StoreController, {
  AdverHotelType,
  CurrentStoreContext,
} from '../../controller/StoreController';
import { useToast } from '../../controller/ToastController';
import { AuthContext } from '../../navigation/AuthProvider';

const AdverHotelIndex = () => {
  const showToast = useToast();
  const { userInfo } = useContext(AuthContext);
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [checkedList, setCheckedList] = useState<AdverHotelType[]>([]);
  const [advertisingList, setAdvertisingList] = useState<AdverHotelType[]>([]);
  const [adHotelCount, setHotelCount] = useState<number>(0);
  const [adDeviceCount, setAdDeviceCount] = useState<number>(0);
  const [hotelList, setHotelList] = useState<AdverHotelType[]>([]);
  const [showAll, setShowAll] = useState<boolean>(false);
  const filteredHotels = showAll
    ? hotelList
    : hotelList.filter((hotel) => hotel.distance < 10 || !hotel.distance);

  const handleCheckboxClick = (item: AdverHotelType) => {
    setCheckedList((prevCheckedList) => {
      const isAlreadyChecked = prevCheckedList.some((hotel) => hotel.store_id === item.store_id);
      return isAlreadyChecked
        ? prevCheckedList.filter((hotel) => hotel.store_id !== item.store_id)
        : [...prevCheckedList, item];
    });
  };

  const getHotelStore = async () => {
    const oParams = {
      store_id: currentStore.value,
    };
    const oResponse = await StoreController.getHotelStore(oParams);
    if (oResponse && oResponse.data) {
      const oRes = oResponse.data;
      if (oRes.data) {
        let deviceCount = 0;
        let listTemp: AdverHotelType[] = [];

        oRes.data.map((item: AdverHotelType) => {
          if (item.is_ad) {
            listTemp.push(item);
            deviceCount += item.room_cnt;
          }
        });
        setCheckedList([]);
        setAdvertisingList([...listTemp]);
        setHotelCount(listTemp.filter((item: AdverHotelType) => item.is_ad).length);
        setAdDeviceCount(deviceCount);
        setHotelList(oRes.data);
      }
    }
  };
  const requestHotelStore = async () => {
    const inCompleteList: AdverHotelType[] = [...checkedList];

    if (checkedList.length > 0) {
      const oParams = checkedList.map((checkedItem) => ({
        user_id: checkedItem.user_id,
        hotel_id: checkedItem.store_id,
        store_id: currentStore.value,
      }));

      const oResponse = await StoreController.requestHotelStore(oParams);
      if (oResponse && oResponse.data) {
        const oRes = oResponse.data;
        if (oRes.data && oRes.data.status === 200) {
          showToast(`호텔에 입점을 신청했어요`);
          getHotelStore();
        } else {
          showToast(oRes.msg, 'error');
        }
      }

    } else {
      showToast(`입점 신청할 호텔을 선택해주세요`, 'error');
    }
  };

  useEffect(() => {
    getHotelStore();
  }, [currentStore]);

  return (
    <>
      <Style>
        <div className="contentContainer">
          <div className="title">
            <h3>우리매장 입점현황</h3>
          </div>
          <div className="listWrap">
            {advertisingList.map((item: AdverHotelType, index: number) => (
              <div className="listItem" key={index}>
                <h3>{item.store_name}</h3>
                <div className="itemContent">
                  <h5>객실 수 {item.room_cnt}개</h5>
                  <div
                    className={`statusBadge ${item.is_ad && 'ad'} ${
                      !item.is_ad && item.confirm_type === 0 && 'check'
                    } ${!item.is_ad && item.confirm_type === 2 && 'reject'} `}>
                    <h5>{item.is_ad ? '광고중' : item.confirm_type === 0 ? '검수중' : '반려됨'}</h5>
                  </div>
                </div>
                {item.confirm_type === 2 && (
                  <span className="comment">반려 사유: {item.confirm_description}</span>
                )}
              </div>
            ))}
            <div className="listItem count">
              <h4>총 호텔 수 {adHotelCount.toLocaleString()}개</h4>
              <h4>총 객실 수 {adDeviceCount.toLocaleString()}개</h4>
            </div>
          </div>
        </div>
        {hotelList.length > 0 && (
          <div className="contentContainer">
            <div className="title">
              <h3>입점 가능 호텔</h3>
              <div className="badge">
                <h4>입점 가능한 호텔이 있어요! 😄</h4>
              </div>
            </div>
            <div className="listWrap">
              {filteredHotels.map((hotel, index) => {
                const isChecked = checkedList.some((item) => item.store_id === hotel.store_id);
                const isSelectable = !hotel.is_ad && hotel.confirm_type === undefined;
                const statusClass = hotel.is_ad
                  ? 'ad'
                  : hotel.confirm_type === 0
                  ? 'check'
                  : hotel.confirm_type === 2
                  ? 'reject'
                  : '';
                const statusText = hotel.is_ad
                  ? '광고중'
                  : hotel.confirm_type === 0
                  ? '검수중'
                  : '반려됨';

                return (
                  <div
                    key={index}
                    className={`listItem notAd ${isSelectable && isChecked ? 'active' : ''}`}
                    onClick={() => handleCheckboxClick(hotel)}>
                    <h3>{hotel.store_name}</h3>
                    <div className="row">
                      <div className="itemContent">
                        <h5>{hotel.distance ? `${hotel.distance}km` : ''}</h5>
                        <h5>객실 수 {hotel.room_cnt}</h5>
                      </div>
                      {isSelectable ? (
                        <div className="checkBox">
                          <img
                            src={`${process.env.PUBLIC_URL}/svg/ic_check_${
                              isChecked ? 'green' : 'gray'
                            }.svg`}
                            alt="check"
                          />
                        </div>
                      ) : (
                        <div className={`statusBadge ${statusClass}`}>
                          <h5>{statusText}</h5>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
              {!showAll && hotelList.some((hotel) => hotel.distance >= 10) && (
                <button className="showButton row" onClick={() => setShowAll(true)}>
                  <p>더 많은 호텔 보기</p>
                  <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_down_grey.svg`} alt="check" />
                </button>
              )}
            </div>
            <button className="submitButton" onClick={requestHotelStore}>
              입점 신청하기
            </button>
          </div>
        )}
      </Style>
    </>
  );
};

export default AdverHotelIndex;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
    padding-bottom: 27px;
  }
  .contentContainer:nth-child(2) {
    padding-top: 60px;
    border-radius: 0 0 10px 10px;
  }

  h3 {
    font-size: 16px;
    font-weight: 500;
    color: #555;
  }
  h4 {
    font-weight: 500;
    color: #4d4d4d;
  }

  .row {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .title {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-bottom: 10px;

    .badge {
      margin-left: 6px;
      padding: 5px 16px 5px 18px;
      background: linear-gradient(90deg, #d186ff 0%, #8a9dff 100%);
      border-radius: 6px;
      h4 {
        font-size: 14px;
        font-weight: 400;
        color: #fff;
      }
    }
  }
  .listWrap {
    display: flex;
    flex-direction: column;
    gap: 8px;
    .listItem {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid #e5e5e5;
      border-radius: 5px;
    }
    h3 {
      padding: 12px 16px;
      font-weight: 500;
    }
    .itemContent {
      display: flex;
      align-items: center;
      gap: 20px;
      h5 {
        font-weight: 500;
        color: #a7a7a7;
      }
    }
    .statusBadge {
      padding: 3px 12px;
      border-radius: 5px;
      margin-right: 16px;

      h5 {
        font-weight: 500;
        color: #fff;
      }
    }
    .ad {
      background: #4dd2ae;
    }
    .check {
      background: #ffa860;
    }
    .reject {
      background: #ff6060;
    }

    .comment {
      position: absolute;
      bottom: 7px;
      right: 24px;
      font-size: 10px;
      line-height: 14px;
      color: #ff6060;
      font-weight: 500;
    }

    .listItem.count {
      padding: 16px 24px;
      margin-bottom: 20px;
      background: #f7f7f7;
      justify-content: flex-end;
      gap: 40px;
    }

    .listItem.notAd {
      .checkBox {
        width: 75px;
        height: 52px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 16px;
        padding: 10px;
        border-left: 1px solid #e5e5e5;
        cursor: pointer;

        img {
          width: 28px;
          height: 28px;
        }
      }
    }
    .listItem.notAd.active {
      border-width: 2px;
      border-color: #4dd2ae;

      .checkBox {
        border-width: 2px;
        border-color: #4dd2ae;
      }
    }
  }
  .showButton {
    margin-top: 16px;
    padding: 4px 0;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border: 1px solid #eee;
    border-radius: 4px;

    p {
      font-size: 16px;
      font-weight: 600;
      color: gray;
    }
  }

  @media (max-width: 800px) {
    h3 {
      font-size: 16px;
    }
    h5 {
      font-size: 12px;
    }

    .row {
      gap: 20px;
    }

    .listWrap {
      gap: 8px;
      .listItem {
        padding: 20px;

        h3 {
          font-size: 12px;
          padding: 0;
        }
      }
      .itemContent {
        gap: 16px;
      }
      .statusBadge {
        padding: 2px 8px;
      }

      .comment {
        bottom: 6px;
        right: 20px;
      }

      .listItem.count {
        padding: 14px 20px;
        margin-bottom: 10px;
        gap: 30px;
        h4 {
          font-size: 14px;
        }
      }

      .listItem.notAd {
        padding: 0 0 0 20px;
        .itemContent {
          padding: 10px 0;
        }
        .checkBox {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 63px;
          height: 40px;
          border-left: 1px solid #e5e5e5;
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }
    .showButton p {
      font-size: 14px;
    }
  }
`;
